import { useMemo } from 'react';

interface UseUrlProps {
  url: string;
  replacers: Array<Replacer>;
}

interface Replacer {
  placeholder: string;
  value: string;
}

const useUrl = ({ url, replacers }: UseUrlProps) =>
  useMemo(() => {
    if (!url) {
      return null;
    }

    let updatedUrl = url;

    replacers.forEach((replacer) => {
      updatedUrl = updatedUrl.replace(`:${replacer.placeholder}`, replacer.value);
    });

    return updatedUrl;
  }, [replacers, url]);

export default useUrl;
